/**
 * Copyright (c) 2024 The Diffusion Studio Authors
 *
 * This Source Code Form is subject to the terms of the Mozilla 
 * Public License, v. 2.0 that can be found in the LICENSE file.
 */

export const WebFonts = {
	'The Bold Font': {
		weights: ['500'],
		url: 'https://diffusion-studio-public.s3.eu-central-1.amazonaws.com/fonts/the-bold-font.ttf',
	},
	'Komika Axis': {
		weights: ['400'],
		url: 'https://diffusion-studio-public.s3.eu-central-1.amazonaws.com/fonts/komika-axis.ttf',
	},
	Geologica: {
		weights: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
		url: 'https://fonts.gstatic.com/s/geologica/v1/oY1l8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckUWE1lELWNN-w.woff2',
	},
	Figtree: {
		weights: ['300', '400', '500', '600', '700', '800', '900'],
		url: 'https://fonts.gstatic.com/s/figtree/v5/_Xms-HUzqDCFdgfMm4S9DaRvzig.woff2',
	},
	Urbanist: {
		weights: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
		url: 'https://fonts.gstatic.com/s/urbanist/v15/L0x-DF02iFML4hGCyMqlbS1miXK2.woff2',
	},
	Montserrat: {
		weights: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
		url: 'https://fonts.gstatic.com/s/montserrat/v26/JTUSjIg1_i6t8kCHKm459WlhyyTh89Y.woff2',
	},
	Bangers: {
		weights: ['400'],
		url: 'https://fonts.gstatic.com/s/bangers/v20/FeVQS0BTqb0h60ACH55Q2J5hm24.woff2',
	},
	Chewy: {
		weights: ['400'],
		url: 'https://fonts.gstatic.com/s/chewy/v18/uK_94ruUb-k-wn52KjI9OPec.woff2',
	},
	'Source Code Pro': {
		weights: ['200', '300', '400', '500', '600', '700', '800', '900'],
		url: 'https://fonts.gstatic.com/s/sourcecodepro/v22/HI_SiYsKILxRpg3hIP6sJ7fM7PqlPevWnsUnxg.woff2',
	},
} as const;
